import RequestApi from "./RequestApi";
import axiosInstance from "@/lib/api/axios";
import {
    authApi,
    purchasesApi,
    usersApi,
    customersApi,
    marketingApi,
    systemEditionApi,
    coreApi,
    categoriesApi,
    supportApi,
    chatApi,
    connectionsApi,
    rolesApi,
    reportsApi,
    walletsApi
} from "./router";
import {dashboardApi} from "@/lib/api/router/dashboardApi";

export const api = new RequestApi(axiosInstance)

const initRoute = [
    ...authApi,
    ...purchasesApi,
    ...usersApi,
    ...customersApi,
    ...marketingApi,
    ...systemEditionApi,
    ...coreApi,
    ...dashboardApi,
    ...categoriesApi,
    ...supportApi,
    ...chatApi,
    ...connectionsApi,
    ...rolesApi,
    ...reportsApi,
    ...walletsApi
]

initRoute.map((route)=>{
    api.addRoute(route)
})